{
  "login": {
    "title": "Connexion",
    "email": "Adresse courriel",
    "password": "Mot de passe",
    "forgotPassword": "Mot de passe oublié?",
    "login": "Connexion",
    "signInWithEmail": "Se connecter avec courriel",
    "signInWithGoogle": "Se connecter avec Google",
    "limitedFeatures": "Validateur de plaques uniquement",
    "limitedFeaturesDescription": "Pour accéder à toutes les fonctionnalités, connectez-vous avec Google.",
    "noStaffAccess": "Ce compte n'a pas accès au centre d'appels. Demandez une invitation à un administrateur.",
    "staffDeactivated": "Ce compte est désactivé. Demandez à un administrateur de le réactiver.",
    "useWorkspaceAccount": "Connectez-vous avec votre compte Google Workspace clicknpark.",
    "signInFailed": "La connexion a échoué. Réessayez."
  }
}
